// components/products/sections/CustomizationSection.jsx
import React, { useState } from "react";
import { Plus, Trash2, Settings } from "lucide-react";

const CustomizationSection = ({
  formData,
  setFormData,
  addCustomizationOption,
  updateCustomizationOption,
  removeCustomizationOption,
}) => {
  const customizationTypes = [
    "Size Adjustment",
    "Engraving",
    "Stone Selection",
    "Metal Color",
    "Chain Length",
    "Finish Type",
    "Personalization",
    "Gift Wrapping",
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Customization Options
        </h3>
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={formData.customizable.isCustomizable}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                customizable: {
                  ...prev.customizable,
                  isCustomizable: e.target.checked,
                },
              }));
              if (
                e.target.checked &&
                formData.customizable.options.length === 0
              ) {
                addCustomizationOption();
              }
            }}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700">Allow Customization</span>
        </label>
      </div>

      {formData.customizable.isCustomizable && (
        <>
          {formData.customizable.options.length > 0 ? (
            <div className="space-y-4">
              {formData.customizable.options.map((option, index) => (
                <div
                  key={index}
                  className="border border-gray-200 rounded-lg p-4"
                >
                  <div className="flex justify-between items-center mb-3">
                    <div className="flex items-center">
                      <Settings className="w-5 h-5 text-gray-400 mr-2" />
                      <h4 className="font-medium text-gray-900">
                        Option #{index + 1}
                      </h4>
                    </div>
                    <button
                      type="button"
                      onClick={() => removeCustomizationOption(index)}
                      className="text-red-600 hover:text-red-800"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Customization Type *
                      </label>
                      <select
                        value={option.type}
                        onChange={(e) =>
                          updateCustomizationOption(
                            index,
                            "type",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="">Select type</option>
                        {customizationTypes.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Price Impact (₹)
                      </label>
                      <input
                        type="number"
                        value={option.priceImpact || 0}
                        onChange={(e) =>
                          updateCustomizationOption(
                            index,
                            "priceImpact",
                            parseFloat(e.target.value) || 0
                          )
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Additional cost"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Available Options *
                      </label>
                      <textarea
                        value={
                          Array.isArray(option.values)
                            ? option.values.join(", ")
                            : option.values || ""
                        }
                        onChange={(e) =>
                          updateCustomizationOption(
                            index,
                            "values",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        rows="2"
                        placeholder="Enter options separated by commas (e.g., Small, Medium, Large)"
                      />
                      <p className="mt-1 text-xs text-gray-500">
                        Separate multiple options with commas
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              <button
                type="button"
                onClick={addCustomizationOption}
                className="w-full py-2 px-4 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-blue-500 hover:text-blue-500 flex items-center justify-center"
              >
                <Plus className="w-4 h-4 mr-2" />
                Add Customization Option
              </button>
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">
              <Settings className="w-12 h-12 mx-auto text-gray-300 mb-2" />
              <p>No customization options configured</p>
              <button
                type="button"
                onClick={addCustomizationOption}
                className="mt-3 text-blue-600 hover:text-blue-700 text-sm font-medium"
              >
                Add your first option
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CustomizationSection;
